// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xyQU","field":"styles_field__1Fahe","fieldCol":"styles_fieldCol__20jlx","diffCol":"styles_diffCol__5Rb0u","diff":"styles_diff__1th4a"};